export default __webpack_public_path__ + "static/media/ponentes___Jose Buganza.dd0d20c4.jpg";